import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Routes} from '@/config/routes';
import {UserInfo} from './kidsplaza-spring.desktop.user-info';
import {UserInfoMenu} from './kidsplaza-spring.desktop.user-info-menu';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import SocialNetwork from '../user-info-card/social-network/social-network';

const bannerDownloadApp = getImageAssetUrl('images/download-app-banner-204x153.png');

export const UserInfoCard = () => {
    return (
        <div className={`hidden w-57.5 rounded-2xl bg-[#d6f1fe] p-2.5 xl:block`}>
            <UserInfo />

            <UserInfoMenu />

            <Link
                href={`${Routes.appDownload}`}
                className="relative mb-2 mt-2 block h-44 w-full transition-opacity hover:opacity-80">
                <Image
                    src={bannerDownloadApp}
                    alt="user-info-bottom-image"
                    width={204}
                    height={153}
                    className="rounded-[10px]"
                />
            </Link>

            <SocialNetwork />
        </div>
    );
};
